import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as tslib_1 from "tslib";
import React from "react";
import ReactDOM from "react-dom";
import { canUseDOM } from "../../utils";
import { ModalPortal } from "./modal-portal";
export var ModalContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalContainer, _React$PureComponent);

  var _super = _createSuper(ModalContainer);

  function ModalContainer(props) {
    var _this;

    _classCallCheck(this, ModalContainer);

    _this = _super.call(this, props);

    if (canUseDOM()) {
      _this.el = _this.document.createElement("div");

      if (props.containerClassName !== undefined) {
        _this.el.className = props.containerClassName;
      }
    }

    return _this;
  }

  _createClass(ModalContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.el !== undefined) {
        this.document.body.appendChild(this.el);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.el !== undefined) {
        this.document.body.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          active = _a.active,
          containerClassName = _a.containerClassName,
          document = _a.document,
          rest = tslib_1.__rest(_a, ["active", "containerClassName", "document"]);

      return this.el !== undefined && active === true ? ReactDOM.createPortal(React.createElement(ModalPortal, Object.assign({
        document: this.document
      }, rest)), this.el) : false;
    }
  }, {
    key: "document",
    get: function get() {
      return this.props.document !== undefined ? this.props.document : document;
    }
  }]);

  return ModalContainer;
}(React.PureComponent);
ModalContainer.displayName = "Modal.Container";